module.exports = __webpack_public_path__ + "img/shirt-on-line.9e215c2a.png";